<div class="d-flex">
  <div class="mt-5px">
    <p class="text-14-regular align-text-vertically first-line">{{title}}</p>
    <p *ngIf="selectedValue" class="align-text-vertically second-line">{{name}}</p>
  </div>
  <div class="select-wrapper">
    <div class="select">
      <div #select class="select-top">
        <button mat-icon-button (click)="onOpen()">
          <mat-icon *ngIf="!isOpened" class="chevron-icon">keyboard_arrow_down</mat-icon>
          <mat-icon *ngIf="isOpened" class="chevron-icon">keyboard_arrow_up</mat-icon>
        </button>
      </div>

      <div class="select-list" #selectList [hidden]="!isOpened">
        <mat-radio-group aria-label="Select an option">
          <div *ngFor="let option of options" class="select-list-item" (click)="onChange(option)">
<!--            <mat-radio-button checked = "{{isChecked(option)}}"></mat-radio-button>-->
            <img *ngIf="selectedValue?.value === option.value" class="selected-item-icon"
                 src="./assets/images/radio_on.svg">
            <img *ngIf="selectedValue?.value !== option.value" class="selected-item-icon"
                 src="./assets/images/radio_off.svg">
            <span class="select-list-item-text align-text-vertically">{{ option.name }}</span>
          </div>
        </mat-radio-group>

      </div>
    </div>
  </div>
</div>


